<template>
  <div id="PageTable">
    <MyBanner :text="$t('documentArea.ddt.banner')" />
    <MyHeaderPage :title="$t('documentArea.ddt.areaTitle')"/>
      <div class="contentPage">
       <div class="mdl-grid" style="align-items: baseline">
          <div class="mdl-cell mdl-cell--4-col">
            <DataPicker v-model="fromDate" :label="$t('filter.from')" />
          </div>
          <div class="mdl-cell mdl-cell--4-col">
            <DataPicker v-model="toDate" :label="$t('filter.to')" />
          </div>
          <div v-if="!IsMobile" class="mdl-cell mdl-cell--2-col mdl-cell--1-offset">
            <div class="cdlButtonGreen" @click="getData()">
              {{ $t("filter.filter") }}
            </div>
          </div>
          <div v-else class="mdl-cell mdl-cell--12-col-phone">
            <div class="cdlButtonGreen" style="width: auto" @click="getData()">
              {{ $t("filter.filter") }}
            </div>
          </div>
        </div>
        <div class="tableList">

          <div v-if="!loaded">
              <MyLoading :viewLoader="loaded" type="" ></MyLoading>
          </div>
          <div v-else>
            <div v-if="!showEmpty">
              <GenericList :header="listHeader" :data="listData">
                <template #cell="{ field, row, colIndex, rowIndex}">
                  <template v-if="colIndex === 3">
                    <button class="cdlButtonGreen" style="display:block; width:200px;" @click="downloadFile(rowIndex, row)">{{$t('documentArea.download')}}</button>
                  </template>
                  <template v-else>
                    {{ field }}
                  </template>
                </template>
              </GenericList>
              <div v-if="totalPage>1">
                <Paginator :totalPage="totalPage" :currentPage="currentPage" @change-page="changePage" @next-page="nextPage" @prev-page="prevPage"></Paginator>
              </div>
            </div>
          <div v-else>
              <h4 style="text-align:center;">{{$t('documentArea.ddt.noDoc')}}</h4>
          </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script setup>
  import MyBanner from "@/components/MyBanner.vue";
  import MyHeaderPage from "@/components/MyHeaderPage.vue";
  import DataPicker from "@/components/Primitives/DataPicker/DataPicker.vue";
  import {ref, computed, watch} from "vue"
  import GenericList from "@/components/Primitives/Lists/GenericList.vue";
  import axios from "axios";
  import { useUserStore } from "@/stores/UserStore";
  import { useI18n } from 'vue-i18n'
  import moment from "moment";
  import MyLoading from "@/components/MyLoading.vue";
  import DownloadBinaryFile from '@/services/FileService'
  import Paginator from "@/components/Paginator.vue";

  const { t } = useI18n()

  const userStore = useUserStore()
  const userToken=userStore.token
  const currentPage=ref(1);
  const totalPage=ref(1)
  const totalResult=ref(1)
  const showEmpty=ref(0)

  const toDate = ref('')
  const fromDate = ref('')
  const loaded = ref(false)
  const listHeader = computed(() => [
    t('documentArea.documentNumber'),
    t('documentArea.documentType'),
    t('documentArea.documentDate'),
    " "
  ])
  const listData=ref([])
  const loadedData=ref([])
  const documentType="DDT"

  fromDate.value=moment().subtract(6, "months").format("YYYY-MM-DD"),
  toDate.value=moment().format("YYYY-MM-DD")

  
  function changePage(page){
    currentPage.value=page
  } 
  function nextPage(){
    if(currentPage.value+1<=totalPage.value){
      currentPage.value=currentPage.value+1
    }
  } 
  function prevPage(){
    if(currentPage.value-1!=0){
      currentPage.value=currentPage.value-1
    }
  }
  watch(currentPage, () => {
    getData();
  })
  

  function downloadFile(rowIndex){
    const fileValue=loadedData.value[rowIndex]
    
    axios.get(
      window.VUE_APP_MISTRA_URL+"documents/v1/document/"+fileValue.id
        , {
          responseType: 'blob',
          params: {
              "document_type" : documentType
          },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + userToken
          },
        }
      )
      .then((results) => {
          DownloadBinaryFile.downloadBlob(results.data, fileValue.filename)
      }).catch(function(err){
        console.log(err)
    });
  }
  
  function getData(){
    loaded.value=false
    axios.get(
          window.VUE_APP_MISTRA_URL+"documents/v1/document", {
            params: {
                "from_date" : fromDate.value,
                "to_date" : toDate.value,
                "document_type" : documentType,
                "page_number" : currentPage.value
            },
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + userToken
            },
          }
        )
        .then((results) => {
          setTimeout(() => {
            loaded.value=true
          }, 1200);
          totalPage.value=results.total_pages
          totalResult.value=results.total_number
          
         
          if(results.data.items !=undefined || results.data.items.lenght>0){
            listData.value=[]
            loadedData.value=results.data.items
            results.data.items.forEach((item)=>{

              //creazione del numero del doc
              let filename="DT/"+String(item.doc_number).padStart(7, '0')+"/"+item.file_date.split("-")[0];
              listData.value.push([filename, t("documentArea.ddt.documentType"), moment(item.file_date, 'YYYY-MM-DD').format('DD/MM/YYYY'), ""])
            });
          }else{
              showEmpty.value=true
              loaded.value=true
          }
        })
        .catch(function () {
          showEmpty.value=true
          loaded.value=true
        });  
  }
  getData();



 

</script>

<style scoped>


</style>
